import React, { useEffect, useState } from "react";
import AddEditForm from "../../AddEditForm";
import { axios } from "../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch,useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ListDataRateCategory from "./ListDataRateCategory";
import PromptElement from "../../PromptElement";
import RateCategoryItems from "./RateCategoryItem/RateCategoryItem";
import { printValidationError } from "../../../../utils/functions";
import { getRateCategory } from "../../../../store/Api";

export default function RateCategory() {

  const location = useLocation();
  const isCreateMode = location.pathname.endsWith("/profession-levels-&-fees/create");
  const isEditMode = location.pathname.includes("/profession-levels-&-fees/edit");
  const [selectedCategoryName,setSelectedCategoryName] = useState('')
  const categoryName = new URLSearchParams(location.search).get('name');  
  const currentUrl = window.location.href;
  const isViewPage = currentUrl.includes('rate-category/');
  
  if (isViewPage) {
    console.log('It is a view page.');
  } else {
    console.log('It is the main page.');
  }
  

  const commonItems = [{ label: 'RATE CATEGORY', link: '/dashboard/rate-category' }];
  const breadcrumbItems = isViewPage
    ? [...commonItems, { label: categoryName?.toUpperCase(), link: '' }]
    : commonItems;

   const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const RateCategoryData = useSelector((state) => state.rateCategoryData);
  useEffect(() => {
   dispatch(getRateCategory(token))
  },[])
  
 
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });
  const [categoryItemsTable, setCategoryItemsTable] = useState({
    categoryId: "",
    open: false,
  });
console.log('caa',categoryItemsTable)

  useEffect(() => {
    if (location.pathname.split("/")[3]) {
      setCategoryItemsTable((p) => ({
        ...p,
        open: true,
        categoryId: location.pathname.split("/")[3],
      }));
    } else {
      setCategoryItemsTable((p) => ({
        open: false,
      }));
    }
  }, [location]);

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems))
  }, [location.pathname]);


  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        name,
        short_description: description,
      };
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/rate-category`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        console.log("edit person", addOrEdit.editId);
        response = await axios.put(`/dashboard/rate-category/${addOrEdit.editId}`,
          body,
          {headers: { Authorization: `Bearer ${token}` }}
        );
      }
      const data = response.data.data;
      if (data) {
       dispatch(getRateCategory(token))
        dispatch(setAppError({
            msg: response.data.message,
            color: "bg-green-700",
        }));
         navigate("/dashboard/rate-category");
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "rateCategory");
      setSubmitFormLoading(false);
      dispatch(setAppError({msg: err.message}));
    }
  };

  const cancelForm = () => {
    navigate("/dashboard/rate-category");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };

  const editData = async (id) => {
    navigate(`/dashboard/rate-category#edit`);

    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        const response = await axios.get(`/dashboard/rate-category/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response.data.data;
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
         dispatch(getRateCategory(token));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setName(data.name);
        setDescription(data.short_description);
      } catch (err) {
        dispatch(setAppError({
            msg: err.message,
        }));
      }
    }
  };

  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/rate-category/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
           dispatch(getRateCategory(token));
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(setAppError({
              msg: response.data.message,
              color: "bg-green-700",
          }));
        }
      } catch (err) {
        console.log(err);
        dispatch(setAppError({
            msg: err.message,
        }));
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(setAppError({
                msg: err?.response?.data.message,
            }));
          }
        }
      }
    }
  };

  const addData = () => {
    navigate("/dashboard/rate-category");
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setName("");
    setDescription("");
  };

  const showCategoryItems = (id,categoryName) => {
    setCategoryItemsTable({ open: true, categoryId: id, rateCategoryName: categoryName });
    setSelectedCategoryName(categoryName)
  }

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      {categoryItemsTable.open ? (
        <RateCategoryItems />
      ) : (
        <div className="p-2  sm:p-5">
          {!addOrEdit.open && (
            <>
              {/* <Link to="/dashboard/rate-category/create">
                <button
                  className="p-2 bg-red text-white rounded-md"
                  onClick={addData}
                >
                  Add New Rate Category +
                </button>
              </Link> */}
              <ListDataRateCategory
                list={RateCategoryData}
                editData={editData}
                deleteData={setShowPromptElement}
                loading={loading}
                column={4}
                showCategoryItems={showCategoryItems}
                titles={[
                  "S.No.",
                  "Rate category",
                  "View Details",
                ]}
              />
            </>
          )}
          {addOrEdit.open && (
            <AddEditForm
              component="rateCategory"
              form={[
                {
                  type: "text",
                  text: "Name",
                  name: "name",
                  value: name,
                  update: setName,
                  columnName: "name",
                },
                {
                  type: "text",
                  text: "Description",
                  name: "description",
                  value: description,
                  update: setDescription,
                  columnName: "short_description",
                },
              ]}
              submitForm={submitForm}
              cancelForm={cancelForm}
              submitFormLoading={submitFormLoading}
              loadedValues={
                addOrEdit.method === "edit" && addOrEdit.loadedValues
              }
            />
          )}
        </div>
      )}
    </>
  );
}